document.addEventListener('DOMContentLoaded', function () {
  const dropdownBtn = document.querySelector('.meta_slider.dropdown-btn');
  const dropdownList = document.querySelector('.meta_slider.dropdown-list');
  const selectedValue = document.querySelector('.meta_slider.selected-value');

  if (dropdownBtn && dropdownList && selectedValue) {
    dropdownBtn.addEventListener('click', function () {
      dropdownList.classList.toggle('open');

      if (dropdownList.classList.contains('open')) {
        dropdownList.style.borderBottom = '1px solid black';
        dropdownList.style.borderTop = '1px solid black';
      } else {
        dropdownList.style.borderBottom = 'none';
        dropdownList.style.borderTop = 'none';
      }
    });

    dropdownList.addEventListener('click', function (e) {
      if (e.target.tagName === 'LI') {
        selectedValue.textContent = e.target.getAttribute('data-value');
        dropdownList.classList.remove('open');
        dropdownList.style.borderBottom = 'none';
        dropdownList.style.borderTop = 'none';
      }
    });

    document.addEventListener('click', function (e) {
      if (!dropdownBtn.contains(e.target)) {
        dropdownList.classList.remove('open');
        dropdownList.style.borderBottom = 'none';
        dropdownList.style.borderTop = 'none';
      }
    });
  }

  // Handle each testimonial slider
  document.querySelectorAll('.meta_products_slider').forEach(function(slider) {
    const reviewText = slider.querySelector('.text');
    const readMoreLink = slider.querySelector('.reed_more');
    const addToCartButton = slider.querySelector('.add-to-cart');

    if (!reviewText || !readMoreLink || !addToCartButton) return;

    const maxLines = 5;
    const lineHeight = parseFloat(window.getComputedStyle(reviewText).lineHeight);
    const maxHeight = lineHeight * maxLines;

    if (reviewText.scrollHeight <= maxHeight) {
      readMoreLink.style.display = 'none';
    }

    reviewText.style.maxHeight = maxHeight + "px";

    readMoreLink.addEventListener('click', function(e) {
      e.preventDefault();

      if (!reviewText.classList.contains('expanded')) {
        reviewText.classList.add('expanded');
        reviewText.style.maxHeight = maxHeight + "px";
        reviewText.offsetHeight;
        reviewText.style.maxHeight = reviewText.scrollHeight + "px";
        readMoreLink.textContent = "Read Less";
      } else {
        reviewText.style.maxHeight = maxHeight + "px";
        readMoreLink.textContent = "Read More";
        reviewText.addEventListener('transitionend', function removeExpanded() {
          reviewText.classList.remove('expanded');
          reviewText.removeEventListener('transitionend', removeExpanded);
        });
      }
    });

    addToCartButton.addEventListener('click', async function(e) {
      e.preventDefault();
      if (addToCartButton.disabled) return;

      const productId = this.getAttribute('data-product-id');
      const qtyEl = slider.querySelector('.meta_slider.selected-value');
      const productQuantity = parseInt(qtyEl?.innerHTML, 10) || 1;

      const items = [{ id: productId, quantity: productQuantity }];

      const mainBtn = document.getElementById('AddtoCartBtn');
      if (mainBtn) {
        const idInput = document.querySelector('input[name="id"]');
        const mainVariantId = idInput ? idInput.value : mainBtn.getAttribute('data-variant-id');
        const mainQty = parseInt(document.getElementById('hiddenqty')?.value, 10) || 1;
        const purchaseType = document.getElementById('purchase_type')?.value;
        const sellingPlanId = purchaseType === 'autodeliver'
          ? document.getElementById('selling_plan')?.value
          : null;
        if (mainVariantId) {
          items.push({
            id: mainVariantId,
            quantity: mainQty,
            ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
          });
        }
      }

      window.setAtcLoading?.(addToCartButton, true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
        const data = await response.json();
        if (typeof pushAddToCartEvent === 'function') pushAddToCartEvent(data);

        if (typeof refreshCartDrawer === 'function') await refreshCartDrawer();
        if (typeof toggleCartDrawer === 'function') toggleCartDrawer(true);
      } catch (error) {
        console.error('[Pair With add-to-cart]', error);
      } finally {
        window.setAtcLoading?.(addToCartButton, false);
      }
    });
  });
});
